// @ts-ignore
import userStore from '@/stores/user/index';

// 获取 Order_specific_landing_page 实验组
const getOrderSpecificLandingPage = () => {
  const controlGroup = (userStore.newABTestingConfigs as any)?.Order_specific_landing_page;

  if (controlGroup === 'test') {
    return true;
  } else {
    return false;
  }
};

export default getOrderSpecificLandingPage;
